<button type="button"
        [class]="'f-button--' + (buttonType ? buttonType : 'primary')"
        [title]="title ? title : ''"
        [ngClass]="componentClass"
        [class.disabled]="disabled"
        [disabled]="disabled"
        (click)="onClick($event)">
  <span [ngClass]="icon" *ngIf="icon && icon.includes('atram-ico') && icon.includes('before')"></span>
  <span [innerHTML]="label" *ngIf="label"></span>
  <span [ngClass]="icon" *ngIf="icon && icon.includes('atram-ico')  && icon.includes('after')"></span>
</button>
